import { enqueueCartMutation } from './cart-api.js';
import { define, emit, EVENTS, announce, afterAdd } from './theme.js';
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.life = new AbortController();
    this.basePrices = null;
    this.form = this.querySelector('form');
    this.form?.addEventListener('change', event => { if (event.target.name === 'selling_plan') this.planPrice(); }, { signal: this.life.signal });
    document.addEventListener(EVENTS.variantChange, event => {
      if (this.id === `BuyButtons-${event.detail.section}`) { this.basePrices = null; this.planPrice(); }
    }, { signal: this.life.signal });
    this.planPrice();
    this.form?.addEventListener('submit', event => this.submit(event), { signal: this.life.signal });
  }
  disconnectedCallback() { this.life.abort(); }
  planPrice() {
    const section = this.id.replace('BuyButtons-', '');
    const targets = ['Price', 'StickyPrice', 'AddToCartPrice', 'StickyButtonPrice'].map(prefix => document.getElementById(`${prefix}-${section}`));
    if (!this.basePrices) this.basePrices = targets.map(target => target?.innerHTML || '');
    const selected = this.form?.querySelector('[name="selling_plan"]:checked');
    const price = selected?.closest('label')?.querySelector('.selling-plans__price');
    targets.forEach((target, index) => {
      if (target) target.innerHTML = selected?.value && price ? price.innerHTML : this.basePrices[index];
    });
  }
  async submit(event) {
    if (!document.querySelector('cart-drawer')) return;
    event.preventDefault();
    if (this.pending || this.closest('[data-variant-loading]') || !this.form.reportValidity()) return;
    this.pending = true;
    const buttons = [...document.querySelectorAll('button[type="submit"]')].filter(button => button.form === this.form);
    const disabled = buttons.map(button => button.disabled);
    const options = [...(this.closest('.product-page')?.querySelectorAll('variant-picker input, variant-picker select') || [])];
    options.forEach(input => { input.disabled = true; });
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const message = this.querySelector('[data-form-message]');
    message.hidden = true;
    try {
      const data = new FormData(this.form);
      if (!data.get('selling_plan')) data.delete('selling_plan');
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      data.set('sections', sectionIds.join(','));
      data.set('sections_url', location.pathname + location.search);
      await enqueueCartMutation(async () => {
      const response = await fetch(`${this.dataset.url}.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const item = await response.json();
      if (!response.ok || item.status) throw new Error(typeof item.description === 'string' ? item.description : this.dataset.errorText);
      if (sectionIds.some(id => !item.sections?.[id])) { location.assign(this.dataset.cartUrl); return; }
      emit(EVENTS.cartUpdate, { sections: item.sections, source: 'product-form', item });
      announce(this.dataset.addedText.replace('{title}', item.product_title || item.title || ''));
      afterAdd(event.submitter || buttons[0]);
      });
    } catch (error) {
      message.textContent = error.message || this.dataset.errorText;
      message.hidden = false;
      message.tabIndex = -1;
      message.focus({ preventScroll: true });
      const bounds = message.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
        message.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    } finally {
      this.pending = false;
      options.forEach(input => { input.disabled = false; });
      buttons.forEach((button, index) => { button.disabled = disabled[index]; button.removeAttribute('aria-busy'); });
    }
  }
}
class GiftCardRecipient extends HTMLElement {
  connectedCallback() {
    this.life = new AbortController();
    this.toggle = this.querySelector('[data-recipient-toggle]');
    this.toggle.addEventListener('change', () => this.update(), { signal: this.life.signal });
    this.update();
  }
  disconnectedCallback() { this.life.abort(); }
  update() {
    this.querySelector('[data-recipient-fields]').hidden = !this.toggle.checked;
    this.querySelectorAll('[data-recipient-field]').forEach(field => { field.disabled = !this.toggle.checked; });
    this.querySelector('[data-recipient-field="email"]').required = this.toggle.checked;
    this.querySelector('[data-recipient-field="offset"]').value = new Date().getTimezoneOffset();
    const date = this.querySelector('[data-recipient-field="send_on"]');
    const today = new Date();
    const local = value => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    date.min = local(today);
    today.setDate(today.getDate() + 90);
    date.max = local(today);
  }
}
define('product-form', ProductForm);
define('gift-card-recipient', GiftCardRecipient);
